import { postData } from './PostData';

export const wishlist = () => {
	const addToWishlistBtn = document.getElementsByClassName('add-to-wishlist');
	const removeFromWishlistBtn = document.getElementsByClassName('remove-from-wishlist');
	
	const addToWishlistHandler = (e) => {
		e.preventDefault();
		document.getElementById('loader').style.display = 'flex';
	
		const form = new FormData();
		form.append('action', 'add_to_wishlist');
		form.append('productId', e.target.dataset.id);
		form.append('_ajax_nonce', my_ajax_object.nonce);
		const params = new URLSearchParams(form);
	
		postData(my_ajax_object.ajax_url, params)
			.then(response => {
				document.getElementById('loader').style.display = 'none';

				if (!response || response.error) {
					return;
				}

				document.getElementById('wishlist-count').innerHTML = response.wishlistItemsCount;
				e.target.classList.add('active');
			});
	}
	
	const removeFromWishlistHandler = (e) => {
		e.preventDefault();
	
		document.getElementById('loader').style.display = 'block';
		const productId = e.target.getAttribute('data-productid');
	
		const form = new FormData();
		form.append('action', 'remove_from_wishlist');
		form.append('productId', productId);
		form.append('_ajax_nonce', my_ajax_object.nonce);
		const params = new URLSearchParams(form);
	
		postData(my_ajax_object.ajax_url, params)
			.then(response => {
				document.getElementById('loader').style.display = 'none';

				if (!response || response.error) {
					return;
				}

				document.getElementById('wishlist-count').innerHTML = response.wishlistItemsCount;
				document.getElementById(productId).remove();
			});
	}

	if (addToWishlistBtn) {
		for (let i = 0; i < addToWishlistBtn.length; i++) {
			addToWishlistBtn.item(i).addEventListener('click', addToWishlistHandler);
		}
	}

	if (removeFromWishlistBtn) {
		for (let i = 0; i < removeFromWishlistBtn.length; i++) {
			removeFromWishlistBtn.item(i).addEventListener('click', removeFromWishlistHandler);
		}
	}
}
